// dashboard/modals/RequestSentModal.js
// Shown once, immediately after request_pet_finalization() commits
// (2026-08-31) — replaces the old CondolencesModal on the clinic side,
// which assumed the clinic's click itself ended monitoring. It no longer
// does: the owner must independently confirm on their own device before
// anything is final, so the clinic only ever sees an acknowledgment that
// the request went out, never a condolences screen (that belongs to
// whoever actually confirms the outcome — the owner, in EditPetScreen or
// the mobile confirmation screen).

import { useTranslation } from 'react-i18next';
import { c } from '../constants';
import { useModalA11y } from '../useModalA11y';

export default function RequestSentModal({ petName, onClose }) {
  const { t } = useTranslation();
  const containerRef = useModalA11y(onClose);

  return (
    <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(79,100,115,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 200 }}>
      <div
        ref={containerRef}
        tabIndex={-1}
        role="dialog"
        aria-modal="true"
        aria-labelledby="request-sent-modal-title"
        style={{ backgroundColor: c.white, borderRadius: 16, padding: 28, width: '100%', maxWidth: 440, boxShadow: '0 8px 32px rgba(79,100,115,0.18)', outline: 'none', textAlign: 'center' }}
      >
        <h2 id="request-sent-modal-title" style={{ fontSize: 17, fontWeight: 600, color: c.slate, marginBottom: 12 }}>
          {t('requestSentModal.title')}
        </h2>
        <p style={{ fontSize: 13, color: c.textSoft, marginBottom: 22, lineHeight: 1.6 }}>
          {t('requestSentModal.body', { petName })}
        </p>
        <button
          onClick={onClose}
          style={{ padding: '9px 20px', backgroundColor: c.moss, color: c.white, border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer' }}
        >
          {t('requestSentModal.close')}
        </button>
      </div>
    </div>
  );
}
